import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import Button from "@material-ui/core/Button";

import { useTranslation } from "../../lang";

const renderInput = ({ input, label, type, meta: { touched, error } }) => (
  <div className="login-field-group">
    <label>{label}</label>
    <input {...input} type={type || "text"} autoComplete="off" />
  </div>
);

const LoginForm = ({ handleLoginSubmit }) => {
  const [t] = useTranslation();

  const _handleLoginSubmit = (event) => {
    event.preventDefault();
    handleLoginSubmit();
  };

  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={_handleLoginSubmit}
      className="login__form"
    >
      <Field
        component={renderInput}
        id="username-login-field"
        name="username"
        label={`${t("Usuario")}:`}
      />
      <Field
        component={renderInput}
        id="password-login-field"
        name="password"
        type="password"
        label={`${t("Contraseña")}:`}
      />
      <Button
        className="login-submit-btn"
        variant="contained"
        type="submit"
        disableElevation
      >
        {t("Ingresar")}
      </Button>
    </form>
  );
};

LoginForm.propTypes = {
  handleLoginSubmit: PropTypes.func,
};

LoginForm.defaultProps = {
  handleLoginSubmit: () => {},
};

export default reduxForm({
  form: "login",
})(LoginForm);
